import api from "./api.js";

export const sendInvitation = async (invitationData) => {
  try {
    const normalizedPayload = {
      email: invitationData.email,
      invitedBy: invitationData.invitedBy,
    };

    const response = await api.post("/invitations/send", normalizedPayload);

    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to send invitation",
    };
  }
};

export const validateInvitationToken = async (token) => {
  try {
    const response = await api.post("/invitations/validate", { token });

    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Invalid invitation token",
    };
  }
};

export const getAllInvitations = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.status) params.append("status", filters.status);
    if (filters.email) params.append("email", filters.email);

    const url = `/invitations?${params.toString()}`;

    const response = await api.get(url);

    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to get invitations",
    };
  }
};

export const resendInvitation = async (invitationId) => {
  try {
    const response = await api.post(`/invitations/resend/${invitationId}`);

    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to resend invitation",
    };
  }
};

export const deleteInvitation = async (invitationId) => {
  try {
    const response = await api.delete(`/invitations/${invitationId}`);

    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to delete invitation",
    };
  }
};

export const cancelInvitation = async (invitationId) => {
  try {
    const response = await api.put(`/invitations/cancel/${invitationId}`);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to cancel invitation",
    };
  }
};

const invitationService = {
  sendInvitation,
  validateInvitationToken,
  getAllInvitations,
  resendInvitation,
  deleteInvitation,
  cancelInvitation,
};

export default invitationService;
